var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77145 10.7142C6.69377 10.8436 6.50613 10.8436 6.42845 10.7142L0.341062 0.568514C0.239143 0.39865 0.419696 0.199876 0.598546 0.285042L6.51401 3.10191C6.56841 3.12781 6.63159 3.12781 6.68599 3.10191L12.6014 0.285049C12.7802 0.199882 12.9608 0.398657 12.8588 0.568521L6.77145 10.7142Z",
    fill: "#F45600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4285 0.28583C6.50618 0.156363 6.69382 0.156363 6.7715 0.285831L12.8589 10.4315C12.9608 10.6013 12.7803 10.8001 12.6014 10.715L6.68594 7.89809C6.63154 7.87218 6.56836 7.87218 6.51397 7.89809L0.598597 10.715C0.419747 10.8001 0.239193 10.6013 0.341112 10.4315L6.4285 0.28583Z",
    fill: "#F45600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.fae2db43cf962164dd2691cffe87afae.svg";
export { ForwardRef as ReactComponent };